import UseAxios from '../../../Api/http/http';
import { MANAGE_KPI_DASHBOARD } from '../../../Constants/strings';
import { getPerformancePeriodDetails } from '../../../Api/request/performance';

export const fetchPerformancePeriodList = async (snackbarOpen) => {

  try {
    const response = await UseAxios(getPerformancePeriodDetails());
    const result = response.data.performancePeriodDetails.map((perforamance) => ({
      id: perforamance.id,
      name: perforamance.cycleName,
      startDate: perforamance.startDate,
      endDate: perforamance.endDate,
    }));
    return result;
  } catch (error) {
    snackbarOpen(MANAGE_KPI_DASHBOARD.OOPS_TRY_AGAIN, 'warning');
    return [];
  }
};
